(() => {
  const menuElements = () => ({
    toggle: document.querySelector('[data-menu-toggle]'),
    close: document.querySelector('[data-menu-close]'),
    menu: document.querySelector('[data-mobile-menu]'),
    scrim: document.querySelector('[data-menu-scrim]')
  });
  const setMenu = (open) => {
    const { toggle, close, menu, scrim } = menuElements();
    if (!menu || !scrim || !toggle) return;
    menu.hidden = !open;
    scrim.hidden = !open;
    toggle.setAttribute('aria-expanded', String(open));
    document.body.classList.toggle('is-menu-open', open);
    document.querySelectorAll('main, .site-footer').forEach(el => { el.inert = open; });
    if (open) close?.focus();
    else toggle.focus();
  };
  document.addEventListener('click', event => {
    if (event.target.closest('[data-menu-toggle]')) setMenu(true);
    if (event.target.closest('[data-menu-close], [data-menu-scrim]')) setMenu(false);
  });
  document.addEventListener('keydown', event => {
    const { menu } = menuElements();
    if (!menu || menu.hidden) return;
    if (event.key === 'Escape') { event.preventDefault(); setMenu(false); }
    if (event.key === 'Tab') {
      const links = [...menu.querySelectorAll('a[href], button:not(:disabled)')];
      const first = links[0], last = links.at(-1);
      if (event.shiftKey && document.activeElement === first) { event.preventDefault(); last.focus(); }
      else if (!event.shiftKey && document.activeElement === last) { event.preventDefault(); first.focus(); }
    }
  });
  const updateHeader = () => document.querySelector('[data-site-header]')?.classList.toggle('is-scrolled', window.scrollY > 18);
  updateHeader();
  window.addEventListener('scroll', updateHeader, { passive: true });
  window.addEventListener('resize', () => {
    if (innerWidth >= 990 && !menuElements().menu?.hidden) setMenu(false);
  });
  document.addEventListener('shopify:section:unload', event => {
    if (event.target.querySelector('[data-mobile-menu]')) {
      document.body.classList.remove('is-menu-open');
      document.querySelectorAll('main, .site-footer').forEach(el => { el.inert = false; });
    }
  });

  document.querySelectorAll('[data-sort-select]').forEach((select) => {
    select.addEventListener('change', () => select.form?.submit());
  });

  // Delegated actions survive Shopify's section HTML replacement.
  const bannerObservers = new Map();
  const updateRail = (rail) => {
    const section = rail.closest('[data-image-banner-collection]');
    const max = Math.max(0, rail.scrollWidth - rail.clientWidth);
    const prev = section.querySelector('[data-ibc-prev]');
    const next = section.querySelector('[data-ibc-next]');
    if (prev) prev.disabled = rail.scrollLeft <= 2;
    if (next) next.disabled = rail.scrollLeft >= max - 2;
    const position = section.querySelector('[data-ibc-position]');
    if (position) {
      const cards = [...rail.querySelectorAll('.ibc__product')];
      const bounds = rail.getBoundingClientRect();
      const visible = cards.map((card, index) => ({index, rect:card.getBoundingClientRect()})).filter(({rect}) => rect.right > bounds.left + 4 && rect.left < bounds.right - 4);
      const first = (visible[0]?.index ?? 0) + 1;
      const last = (visible.at(-1)?.index ?? cards.length - 1) + 1;
      position.textContent = `${String(first).padStart(2, '0')}—${String(last).padStart(2, '0')} / ${String(cards.length).padStart(2, '0')}`;
      position.closest('.ibc__position').style.setProperty('--rail-progress', `${cards.length ? last / cards.length * 100 : 0}%`);
    }
  };
  const initBanners = (root = document) => {
    root.querySelectorAll('[data-ibc-rail]').forEach((rail) => {
      if (bannerObservers.has(rail)) return;
      const update = () => updateRail(rail);
      const observer = new ResizeObserver(update);
      observer.observe(rail);
      rail.addEventListener('scroll', update, { passive: true });
      bannerObservers.set(rail, { observer, update });
      update();
    });
  };
  const moveRail = (rail, direction) => {
    const card = rail.querySelector('.ibc__product');
    const gap = Number.parseFloat(getComputedStyle(rail).columnGap) || 0;
    const step = (card?.getBoundingClientRect().width || rail.clientWidth) + gap;
    rail.scrollBy({ left: step * direction, behavior: matchMedia('(prefers-reduced-motion: reduce)').matches ? 'instant' : 'smooth' });
  };
  initBanners();
  document.addEventListener('shopify:section:load', (event) => initBanners(event.target));
  document.addEventListener('shopify:section:unload', (event) => {
    event.target.querySelectorAll('[data-ibc-rail]').forEach((rail) => {
      const state = bannerObservers.get(rail);
      state?.observer.disconnect();
      rail.removeEventListener('scroll', state?.update);
      bannerObservers.delete(rail);
    });
  });
  document.addEventListener('keydown', (event) => {
    if (!event.target.matches('[data-ibc-rail]')) return;
    if (event.key === 'ArrowRight' || event.key === 'ArrowLeft') {
      event.preventDefault();
      moveRail(event.target, event.key === 'ArrowRight' ? 1 : -1);
    }
  });
  const activatePalette = (tab, focus = false) => {
    const root = tab.closest('[data-color-story]');
    if (!root) return;
    root.querySelectorAll('[data-palette-tab]').forEach(item => {
      const active = item === tab;
      item.setAttribute('aria-selected', String(active));
      item.tabIndex = active ? 0 : -1;
    });
    root.querySelectorAll('[data-palette-panel]').forEach(panel => {
      panel.hidden = panel.dataset.paletteId !== tab.dataset.paletteTab;
    });
    const link = root.querySelector('[data-palette-shop]');
    if (link) {
      link.href = tab.dataset.paletteLink;
      link.querySelector('[data-palette-link-name]').textContent = ' — ' + tab.dataset.paletteName;
    }
    if (focus) tab.focus();
  };
  const updatePriceDisplay = (price, currentText, compareText, currentCents, compareCents) => {
    if (!price) return;
    const current = price.querySelector('.price__current');
    if (current) current.textContent = currentText || '—';
    const sale = Boolean(compareText) && Number(compareCents) > Number(currentCents);
    let compare = price.querySelector('.price__compare');
    if (!compare && sale) {
      compare = document.createElement('s');
      compare.className = 'price__compare';
      price.append(compare);
    }
    if (compare) {
      compare.textContent = sale ? compareText : '';
      compare.hidden = !sale;
    }
    let label = price.querySelector('[data-price-sale-label]');
    if (!label && sale) {
      label = document.createElement('span');
      label.className = 'price__sale-label';
      label.dataset.priceSaleLabel = '';
      price.append(label);
    }
    if (label) {
      const saving = sale ? Math.round((Number(compareCents) - Number(currentCents)) / Number(compareCents) * 100) : 0;
      label.textContent = sale ? `Save ${saving}%` : '';
      label.hidden = !sale;
    }
    price.dataset.priceCents = currentCents || '';
    price.dataset.compareCents = sale ? compareCents : '';
    price.classList.toggle('price--sale', sale);
  };
  document.addEventListener('click', event => {
    const tab = event.target.closest('[data-palette-tab]');
    if (tab) activatePalette(tab);
    const swatch = event.target.closest('[data-card-swatch]');
    if (!swatch || event.ctrlKey || event.metaKey || event.shiftKey || event.altKey || event.button !== 0) return;
    event.preventDefault();
    const card = swatch.closest('.ibc-card');
    const photo = card.querySelector('.ibc-card__image--primary');
    if (photo && swatch.dataset.image) {
      photo.src = swatch.dataset.image;
      photo.removeAttribute('srcset');
      photo.alt = swatch.dataset.name;
      card.classList.add('is-variant-preview');
    }
    card.querySelectorAll('[data-card-swatch]').forEach(item => {
      if (item === swatch) item.setAttribute('aria-current', 'true');
      else item.removeAttribute('aria-current');
    });
    card.querySelectorAll('[data-card-link], .ibc-card__quick-add a').forEach(link => { link.href = swatch.href; });
    const price = card.querySelector('.ibc-card__content .price');
    updatePriceDisplay(price, swatch.dataset.price, swatch.dataset.compare, swatch.dataset.priceCents, swatch.dataset.compareCents);
    const select = card.querySelector('[data-quick-view-variant]');
    if (select && [...select.options].some(option => option.value === swatch.dataset.variant && !option.disabled)) {
      select.value = swatch.dataset.variant;
      select.dispatchEvent(new Event('change', { bubbles: true }));
    }
    card.querySelector('[data-swatch-status]').textContent = swatch.dataset.name + ' — ' + swatch.dataset.price;
  });
  document.addEventListener('keydown', event => {
    const tab = event.target.closest('[data-palette-tab]');
    if (!tab) return;
    const tabs = [...tab.closest('[data-color-story]').querySelectorAll('[data-palette-tab]')];
    let index = tabs.indexOf(tab);
    if (event.key === 'ArrowDown' || event.key === 'ArrowRight') index = (index + 1) % tabs.length;
    else if (event.key === 'ArrowUp' || event.key === 'ArrowLeft') index = (index - 1 + tabs.length) % tabs.length;
    else if (event.key === 'Home') index = 0;
    else if (event.key === 'End') index = tabs.length - 1;
    else return;
    event.preventDefault();
    activatePalette(tabs[index], true);
  });
  document.addEventListener('shopify:block:select', event => {
    const tab = event.target.closest('[data-palette-tab]') || event.target.querySelector('[data-palette-tab]');
    if (tab) activatePalette(tab);
  });
  const dialogOpeners = new WeakMap();
  document.addEventListener('click', (event) => {
    const arrow = event.target.closest('[data-ibc-prev], [data-ibc-next]');
    if (arrow) {
      const rail = arrow.closest('[data-image-banner-collection]').querySelector('[data-ibc-rail]');
      if (rail) moveRail(rail, arrow.hasAttribute('data-ibc-next') ? 1 : -1);
    }
    const opener = event.target.closest('[data-quick-view-open]');
    if (opener) {
      const dialog = document.getElementById(opener.dataset.quickViewOpen);
      if (dialog?.showModal) {
        event.preventDefault();
        dialogOpeners.set(dialog, opener);
        dialog.returnFocusTarget = opener;
        dialog.showModal();
      }
      return;
    }
    const closer = event.target.closest('[data-quick-view-close]');
    if (closer) closer.closest('[data-quick-view-dialog]')?.close();
    if (event.target.matches('[data-quick-view-dialog]')) {
      const bounds = event.target.getBoundingClientRect();
      if (event.clientX < bounds.left || event.clientX > bounds.right || event.clientY < bounds.top || event.clientY > bounds.bottom) event.target.close();
    }
  });
  document.addEventListener('close', (event) => {
    if (event.target.matches('[data-quick-view-dialog]')) {
      const opener = dialogOpeners.get(event.target);
      if (opener?.isConnected) opener.focus();
    }
  }, true);
  document.addEventListener('change', (event) => {
    if (!event.target.matches('[data-quick-view-variant]')) return;
    const option = event.target.selectedOptions[0];
    const dialog = event.target.closest('[data-quick-view-dialog]');
    const quantity = dialog.querySelector('input[name="quantity"]');
    if (quantity) {
      quantity.min = option.dataset.min || '1';
      quantity.step = option.dataset.step || '1';
      if (option.dataset.max) quantity.max = option.dataset.max;
      else quantity.removeAttribute('max');
      quantity.value = quantity.min;
    }
    const detailLink = dialog.querySelector('[data-quick-view-details]');
    if (detailLink && option.dataset.url) detailLink.href = option.dataset.url;
    const price = dialog.querySelector('.price');
    const photo = dialog.querySelector('.quick-view__media img');
    if (photo && option.dataset.image) {
      photo.src = option.dataset.image;
      photo.removeAttribute('srcset');
    }
    updatePriceDisplay(price, option.dataset.price, option.dataset.compare, option.dataset.priceCents, option.dataset.compareCents);
  });

  if (!customElements.get('product-recommendations')) {
    customElements.define('product-recommendations', class extends HTMLElement {
      connectedCallback() {
        const url = this.dataset.url;
        if (!url) return;
        fetch(url)
          .then((response) => response.text())
          .then((text) => {
            const html = new DOMParser().parseFromString(text, 'text/html');
            const recommendations = html.querySelector('product-recommendations');
            if (recommendations?.innerHTML.trim().length) this.innerHTML = recommendations.innerHTML;
          })
          .catch(() => {});
      }
    });
  }
})();
